import { normalizeInput } from './format';

export const filterOption = (input, option) => {
    return normalizeInput(option.props.children).includes(normalizeInput(input));
};
